<template>
  <div id="inse-history" style="overflow: hidden">
    <div v-if="inseLoadFlg" class="inse-load">
      <dv-loading>Loading....</dv-loading>
    </div>
    <div class="inseHistory-data">
      <div class="inseHistory-data-head">
        <div class="inseHistory-head-title">
          <div class="inseHistory-title-container">杀虫灯历史数据</div>
        </div>

        <div class="inseHistory-head-select">
          <div class="inseHistory-select-device">
            <el-select @change="inseHistoryChange($event)" v-model="defaultInseDevice" filterable :disabled="inseLoadFlg">
              <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in inseHistoryList">
                <span :class="item.state === 'red' ? 'red-circle' : 'green-circle'"></span>
                {{ item.name }}
              </el-option>
            </el-select>
          </div>

          <div class="inseHistory-select-attribute">
            <el-select @change="inseAttrChange($event)" v-model="defaultInseAttr" filterable :disabled="inseLoadFlg">
              <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in inseAttrList">
              </el-option>
            </el-select>
          </div>

          <div class="inseHistory-select-time">
            <el-date-picker @change="inseSelectTime" v-model="defaultInseTime" unlink-panels type="datetimerange" :picker-options="insePickerOptions" align="right" :disabled="inseLoadFlg"
                            end-placeholder="结束日期" key="time" range-separator="至" start-placeholder="开始日期">
            </el-date-picker>
          </div>

          <div class="inseHistory-select-agg">
            <el-dropdown @command="inseSelectAgg" :disabled="inseLoadFlg">
              <span class="el-dropdown-link">
                {{inseAggValue}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item command="1">最大值</el-dropdown-item>
                <el-dropdown-item command="2">最小值</el-dropdown-item>
                <el-dropdown-item command="3">平均值</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <div class="inseHistory-head-btn">
          <div class="inseHistory-head-btnContainer">
            <el-button type="primary" @click="inseQueryData()" :disabled="inseLoadFlg">查询</el-button>
            <el-button type="warning" @click="inseExportData()" :disabled="inseLoadFlg">导出</el-button>
            <el-button type="danger" @click="inseChangeChart()" :disabled="inseLoadFlg">{{inseChartName}}</el-button>
          </div>
        </div>

      </div>
      <div class="inseHistory-data-content" style="overflow: auto;">
        <div class="inseHistory-content-table" v-show="inseChartNum == 1 ? true : false">
          <el-table  :data="inseTableData.slice((inseCurrentPage-1)*insePageSize,inseCurrentPage*insePageSize)" border>
            <el-table-column prop="ts" label="日期" style="width: 40%"></el-table-column>
            <el-table-column prop="name" label="名称" style="width: 30%"></el-table-column>
            <el-table-column prop="value" label="值" style="width: 30%"></el-table-column>
          </el-table>
          <el-pagination @size-change="inseSizeChange" @current-change="inseCurrentChange" :current-page="inseCurrentPage" style="text-align: center; margin-top: 0.3%"
                         :page-sizes="[15, 30, 50, 100]"  :page-size="insePageSize" layout="total, sizes, prev, pager, next, jumper" :total="inseTableData.length">
          </el-pagination>
        </div>

        <div class="inseHistory-content-chart" v-show="inseChartNum == 2 ? true : false">
          <div class="inseProChart"  id="inseChart">
            <img src="../img/bg1.png" v-show="!inseShow">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import {getTimeDeviceHistory} from "../../until/api/MeteSoil";

  export default {
    name: 'InseHistoryData',
    components: {},
    computed: {},

    data(){
      return {
        inseDeviceList: [],
        inseHistoryList: [],
        defaultInseDevice: '',
        inseAttrList:[],
        defaultInseAttr: '',
        defaultInseTime: [moment().format("YYYY-MM-DD HH:mm:ss"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm:ss")],
        insePickerOptions: {
          shortcuts: [
            {
              text: '最近一天',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        },
        startTime: '',
        endTime: '',
        inseAggSelect: '1',
        inseAggValue: '最大值',
        inseInterval: '',
        inseAgg: '',
        inseChartNum: 1,
        inseChartName: '折线图',
        inseDeviceId: {},
        inseTableData:[],
        inseTimeValue:[],
        inseDataValue:[],
        inseShow: false,
        inseOption: {},
        inseCurrentPage: 1,
        insePageSize: 15,
        inseErrorNum: 0,
        inseLoadFlg: false,
      }
    },

    mounted() {
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')): this.$route.params.customerId;

      let that = this;
      this.$MeteSoilCommon.getDeviceList(authority, customerId, function (deviceList) {
        that.inseHistoryDeviceBoards(deviceList);
      })
    },

    methods: {
      inseHistoryDeviceBoards(response) {
        // this.inseDeviceList = [];
        // if(response.data.length === 0) return;
        // for(let i = 0; i < response.data.length; i++) {
        //   let inseJson = {};
        //   inseJson.id = response.data[i].id.id;
        //   inseJson.name = response.data[i].name;
        //   inseJson.type = response.data[i].id.entityType;
        //   this.inseDeviceList.push(inseJson);
        // }
        // if(this.inseDeviceList.length > 0) {
        //   this.defaultInseDevice = this.inseDeviceList[0].id;
        //   this.inseHistoryAttr();
        // }

        this.inseDeviceList = [];
        if(response.data.length === 0) return;
        let promises = [];
        for(let i = 0; i < response.data.length; i++) {
          let inseJson = {
            id: response.data[i].id.id,
            name: response.data[i].name,
            type: response.data[i].id.entityType
          };

          let promise = this.$MeteSoilCommon.getLastConnectTime(inseJson.type, inseJson.id).then(time => {
            let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
            inseJson.state = time < beforeTime ? 'red' : 'green';
            return inseJson;
          });

          promises.push(promise);
        }

        Promise.all(promises).then(result => {
          this.inseDeviceList = result;
          if(this.inseDeviceList.length > 0) {
            this.inseHistoryDevice(0, this.inseDeviceList.length);
          }
        })
      },

      inseHistoryDevice(j, length) {
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.inseDeviceList[j].id, function (deviceInfo) {
          that.$MeteSoilCommon.getDeviceKeyList(deviceInfo, function (keyData) {
            that.inseKeyOperate(j, keyData);
            if(++j < length) {
              that.inseHistoryDevice(j, length);
            }
          })
        })
      },

      inseKeyOperate(j, keyData) {
        let strKey = '';
        let keyList = keyData.split(',');
        for(let i = 0; i < keyList.length; i++) {
          if(keyList[i].indexOf('fxd_') >= 0) {
            i == keyList.length - 1 ? strKey += keyList[i] : strKey += keyList[i] + ',';
          }
        }

        if(strKey != '') {
          this.inseHistoryList.push(this.inseDeviceList[j]);
          if(this.defaultInseDevice == '') {
            this.defaultInseDevice = this.inseHistoryList[0].id;
            this.inseHistoryAttr();
          }
        }
      },

      inseHistoryChange(event) {
        this.defaultInseDevice = event;
        this.setEmptyInseOption();
        this.inseTableData = [];
        this.inseTimeValue = [];
        this.inseDataValue = [];
        this.inseHistoryAttr();
      },

      inseHistoryAttr() {
        this.inseAttrList = [];
        this.defaultInseAttr = '';
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.defaultInseDevice, function (deviceInfo) {
          that.inseDeviceId = deviceInfo;
          that.$MeteSoilCommon.getDeviceKeyList(deviceInfo, function (keyData) {
            let keyList = keyData.split(',');
            for(let i = 0; i < keyList.length; i++) {
              if(keyList[i].indexOf('fxd_') >= 0) {
                let keyJson = {};
                keyJson.id = keyList[i];
                keyJson.name = that.$t(keyList[i]).split(',')[0];
                that.inseAttrList.push(keyJson);
              }
            }
            that.inseAttrList.length == 0 ? that.defaultInseAttr = '' : that.defaultInseAttr = that.inseAttrList[0].id;
          });
        });
      },

      inseAttrChange(event) {
        this.defaultInseAttr = event;
        this.setEmptyInseOption();
        this.inseTableData = [];
        this.inseTimeValue = [];
        this.inseDataValue = [];
      },

      inseSelectTime(val) {
        if(val === null) {
          this.defaultInseTime = [moment().format("YYYY-MM-DD HH:mm:ss"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm:ss")];
          this.startTime = '';
          this.endTime = '';
        } else {
          this.startTime = new Date(val[0]).getTime();
          this.endTime = new Date(val[1]).getTime();
        }
      },

      inseSelectAgg(event) {
        switch (event) {
          case "1":
            this.inseAggSelect = "1";
            this.inseAggValue = "最大值";
            break;
          case "2":
            this.inseAggSelect = "2";
            this.inseAggValue = "最小值";
            break;
          case "3":
            this.inseAggSelect = "3";
            this.inseAggValue = "平均值";
            break;
        }
      },

      inseQueryData() {
        if(this.defaultInseAttr == '') return;
        this.inseTableData = [];
        this.inseTimeValue = [];
        this.inseDataValue = [];
        this.inseCurrentPage = 1;
        this.setEmptyInseOption();
        if(this.startTime === '' || this.endTime === '') return;
        let time = this.endTime - this.startTime;
        this.inseLoadFlg = true;
        if(time <= 1000 * 60 * 60 *24) {
          this.inseAgg = 'NONE';
          this.inseInterval = 0;
        } else {
          switch (this.inseAggSelect) {
            case "1":
              this.inseAgg = 'MAX';
              this.getInseInterval();//设置聚合时间间隔
              break;
            case "2":
              this.inseAgg = 'MIN';
              this.getInseInterval();//设置聚合时间间隔
              break;
            case "3":
              this.inseAgg = 'AVG';
              this.getInseInterval();//设置聚合时间间隔
              break;
          }
        }
        this.getInseHistory();
      },

      getInseInterval() {
        let intervalTime = (this.endTime - this.startTime) / (1000 * 60 * 60 * 24);
        if(intervalTime > 1 && intervalTime < 30) {
          switch (true) {
            case intervalTime > 1 && intervalTime <= 3:
              this.inseInterval = 1000 * 60 * 10;
              break;
            case intervalTime > 3 && intervalTime <=5:
              this.inseInterval = 1000 * 60 * 15;
              break;
            case intervalTime > 5 && intervalTime <= 10:
              this.inseInterval = 1000 * 60 * 30;
              break;
            case intervalTime > 10 && intervalTime <= 20:
              this.inseInterval = 1000 * 60 * 60;
              break;
            case intervalTime > 20:
              this.inseInterval = 1000 * 60 * 60 * 2;
              break;
          }
        } else if(intervalTime >= 30) {
          switch (true) {
            case intervalTime === 30:
              this.inseInterval = 1000 * 60 * 60 * 2;
              break;
            case intervalTime > 30 && intervalTime <= 90:
              this.inseInterval = 1000 * 60 * 60 * 5;
              break;
            case intervalTime > 90 && intervalTime <= 180:
              this.inseInterval = 1000 * 60 * 60 * 10;
              break;
            case intervalTime > 180 && intervalTime <= 240:
              this.inseInterval = 1000 * 60 * 60 * 12;
              break;
            case intervalTime > 240:
              this.inseInterval = 1000 * 60 * 60 * 24;
              break;
          }
        }
      },

      inseChangeChart() {
        if(this.inseChartNum == 1) {
          this.inseChartNum = 2;
          this.inseChartName = '数字表';
          if(this.inseDataValue.length == 0) {
            this.setEmptyInseOption();//清空折线图
          } else {
            this.$nextTick(() => {
              this.setInseOption();//刷新折线图
            })
          }
        } else {
          this.inseChartNum = 1;
          this.inseChartName = '折线图';
        }
      },

      getInseHistory() {
        this.inseErrorNum++;
        getTimeDeviceHistory(this.inseDeviceId.entityType, this.inseDeviceId.id, this.defaultInseAttr, this.startTime, this.endTime, this.inseInterval, this.inseAgg). then(response => {
          this.inseErrorNum = 0;
          if(JSON.stringify(response.data) == "{}") {
            this.inseLoadFlg = false;
            return;
          }
          for(let obj in response.data) {
            for(let i = 0; i < response.data[obj].length; i++) {
              let tableJson = {};
              tableJson.ts = this.$commonFun.dateFormat(response.data[obj][i].ts);
              tableJson.name = this.$t(this.defaultInseAttr).split(',')[0];
              let unit = this.$t(this.defaultInseAttr).split(',')[1] === undefined ? '' : this.$t(this.defaultInseAttr).split(',')[1];
              if(this.defaultInseAttr == 'fxd_latitude' || this.defaultInseAttr == 'fxd_longitude') {
                tableJson.value = parseFloat(response.data[obj][i].value).toFixed(5) + unit;
              } else if(this.defaultInseAttr == 'fxd_fanMode' || this.defaultInseAttr == 'fxd_uvMode') {
                tableJson.value = response.data[obj][i].value == 1 ? '开启' : '关闭';
              } else {
                tableJson.value = parseFloat(response.data[obj][i].value).toFixed(2) + unit;
              }
              this.inseTimeValue.push(this.$commonFun.dateFormat(response.data[obj][i].ts));
              if(this.defaultInseAttr == 'fxd_latitude' || this.defaultInseAttr == 'fxd_longitude') {
                this.inseDataValue.push(parseFloat(response.data[obj][i].value).toFixed(5));
              } else {
                this.inseDataValue.push(parseFloat(response.data[obj][i].value).toFixed(2));
              }
              this.inseTableData.push(tableJson);
            }
          }
          this.$nextTick(() => {
            this.setInseOption();
          });
          this.inseLoadFlg = false;
        }).catch(error => {
          if(this.inseErrorNum > 4) {
            this.inseLoadFlg = false;
            this.inseErrorNum = 0;
            console.log("error", error);
          } else {
            this.getInseHistory();
          }
        })
      },

      inseSizeChange(size) {
        this.insePageSize = size;
      },

      inseCurrentChange(currentPage) {
        this.inseCurrentPage = currentPage;
      },

      setInseOption() {
        let that = this;
        let unit = this.$t(this.defaultInseAttr).split(',')[1] === undefined ? '' : '(' + this.$t(this.defaultInseAttr).split(',')[1] + ')';
        this.inseOption = {
          color: ['#FEC00A',],
          title: {
            text: this.$t(this.defaultInseAttr).split(',')[0],
            left: 'center', //居中
            textStyle: {
              color: '#ffffff',
              fontSize: 22,
              lineHeight: 35,
              fontWeight: 'normal'
            }
          },
          tooltip: { //提示框
            trigger: 'axis',
            backgroundColor: "rgba(128, 128, 128, 0.5)",
            borderWidth: 1, //边框宽度设置1
            borderColor: "rgba(49, 73, 99, 1)", //设置边框颜色
            borderRadius: 4,
            padding: 5,
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'line' // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function (params) {
              if(that.defaultInseAttr == 'fxd_fanMode' || that.defaultInseAttr == 'fxd_uvMode') {
                let time = params[0].axisValue; // 获取时间
                let value = parseInt(params[0].data) == 1 ? "开启" : "关闭"
                return "时间" + '：' + time + '<br>' + "值" + '：' + value;
              } else {
                let time = params[0].axisValue; // 获取时间
                let value = params[0].data; // 获取数值
                return "时间" + '：' + time + '<br>' + "值" + '：' + value;
              }
            }
          },
          grid: {
            left: '1%',
            right: '5%',
            bottom: '5%',
            top:'10%',
            containLabel: true //grid区域是否包含坐标轴的刻度标签
          },
          xAxis: {
            name: '时间',
            type: 'category', //坐标轴类型。
            nameTextStyle:{
              color:'#fff',
              fontSize :14//字体大小
            },
            boundaryGap: true, //坐标轴两边留白策略
            data: this.inseTimeValue,
            offset: 8,
            axisLabel: {//坐标轴刻度标签的相关设置
              // rotate: 30,
              interval: 'auto',
              rotate: -50,
              show: true,
              textStyle: {
                color: '#fff',
                fontSize :12//字体大小
              },
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                // color:'#3a4650'// rgb(2,121,253)
                color: 'rgba(231, 244, 255, 0.2)'
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            }
          },
          yAxis: {
            name: '数值' + unit,
            type: 'value',
            nameTextStyle:{
              color:'#fff',
              fontSize :14//字体大小
            },
            show: true, //隐藏坐标
            axisLabel: { //y轴的坐标文字
              show: true, //不显示坐标控件
              textStyle: {
                color: '#fff', //文字的颜色
                fontSize :16//字体大小
              },
            },
            // max:this.max,//最大值
            // min:this.min,
            splitLine:{  //坐标在grid区域的分割线
              show: false,// 不显示网格
              lineStyle: { //设置分割线的样式(图表横线颜色)
                color: ['#153a8a'] //网格颜色
              }
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                color:'rgba(231, 244, 255, 0.2)'//#3a4650  rgb(2,121,253) #3a4650
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            },
          },
          series: [
            {
              type: 'line',
              data: this.inseDataValue,
              symbolSize: 10,
              smooth: true,
              animationDuration: 1000,
              lineStyle:{
                color:'#FEC00A'
              },
              tooltip: { //提示框
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                  type: 'line' // 默认为直线，可选为：'line' | 'shadow'
                },
              },
            },
          ],
          dataZoom: [
            {
              endValue: 15, //一次显示10个
              type: 'slider',//有滑动条
              show: true,//是否显示滑动条
              xAxisIndex: [0],//开始下标
              handleSize: 0,//滑动条的左右2个滑动条大小
              height: 20, //滑动条高度
              left: "0%",//左边距离
              right: "0%",//右边距离
              bottom: 0,//底部距离
              // borderColor: "#3a4650", //边框颜色
              borderColor: "#101f3e", //边框颜色
              fillerColor: "#4C7C98",//选中区域的背景色#345A7C#4878fe
              borderRadius: 5,//边框弧度
              //backgroundColor: "#1c2735",//未选区域中的背景色
              backgroundColor:'#0b2d4c',
              showDataShadow: false, //是否显示数据阴影
              showDetail:false,//拖动时是否显示数值
              realtime: true,// 是否实时更新
              filterMode: "filter",
            },
            {
              //左右滑动
              type: "inside",
              show: true,
              xAxisIndex: [0],
              start: 0,
              end: 100,
            }
          ]
        }
        this.inseCharts();
      },

      setEmptyInseOption() {
        this.inseOption = {};
        this.inseCharts();
      },

      inseCharts() {
        document.getElementById("inseChart").removeAttribute("_echarts_instance_");
        let chartOption = this.$echarts.init(document.getElementById('inseChart'));
        chartOption.setOption(this.inseOption);

        window.addEventListener("resize",function(){
          chartOption.resize()  // myChart 是实例对象
        })
      },

      inseExportData() {
        let that = this;
        if(that.inseTableData.length == 0) {
          that.$message({
            showClose: true,
            type: 'warning',
            message: '未查询到数据',
            duration: 5000
          });
          return;
        }
        const {export_json_to_excel} = require('../../vendor/Export2Excel')
        const tHeader = ["名称", "时间", "值"];
        const filterVal = ['name', 'ts', 'value'];
        const list = that.inseTableData;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, this.$t(this.defaultInseAttr).split(',')[0] + "_历史数据");
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      }
    }
  }
</script>

<style lang="less">
  @import "../less/InseHistoryData";
</style>

<style>
  .inseHistory-data-content::-webkit-scrollbar {
    display: none;
  }

  .red-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    margin-right: 5px;
  }

  .green-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/InseHistoryData.vue